module.exports = {
	USER_PERMISSIONS: {
		FULL_ACCESS: "full access",
		CREATE_AND_ASSIGN_USERS: "create and assign users",
		EDIT_USERS: "edit users",
		DELETE_USERS: "delete users",
		CREATE_ENTITIES: "create entities",
		EDIT_ENTITY: "edit entity",
		DELETE_ENTITIY: "delete entitiy",
		VIEW_ENTITY: "view entity",
		UNASSIGN_USERS: "unassign users",
		VIEW_USERS: "view users",
		VIEW_TOPICS: "view topics",
		CREATE_TOPICS: "create topics",
		EDIT_TOPICS: "edit topics",
		DELETE_TOPICS: "delete topics",
		EDIT_ENTITY_TIER: "edit entity tier",
		DEACTIVATE_ENTITY: "deactivate entity"
	},
	ENTITY_FEATURES: {
		NUMBER_OF_TOPICS: "numberOfTopics",
		VOTE_ANALYSIS: "voteAnalysis",
		QNA_ANALYSIS_BASIC: "qnaAnalysisBasic",
		TOPIC_EDIT: "topicEdit",
		QNA_ANALYSIS_DETAILED: "qnaAnalysisDetailed",
		DATA_FILTERING: "dataFiltering",
		HAS_CUSTOM_DATE_RANGE: "hasCustomDateRange",
		CHARTS_EXPORT: "chartsExport",
		HAS_DATA_EXPORT: "hasDataExport",
		ADVANCED_FILTERING: "advancedFiltering",
		HAS_SOURCES_CHART: "hasSourcesChart",
		API_INTEGRATIONS: "apiIntegrations",
		CUSTOM_API: "customApi",
		HAS_PRIVATE_TOPICS: "hasPrivateTopics",
		CUSTOM_TOPIC_IMAGE: "customTopicImage",
		HAS_TOPIC_ALERTS: "hasTopicAlerts",
		ATTACH_REPLY_IMAGE: "attachReplyImage",
		JUMP_QUESTIONS: "jumpQuestions",
		LINK_SOURCES_CONFIG: "linkSourcesConfig",
		LINK_SHARING_CONFIG: "linkSharingConfig",
		AFTER_VOTE_CONFIG: "afterVoteConfig",
		MULTI_LANGUAGES: "multiLanguages",
		PRESENTER_MODE: "presenterMode",
		NUMBER_OF_USERS: "numberOfUsers",
		NUMBER_OF_MANAGERS: "numberOfManagers",
		NUMBER_OF_ENTITIES: "numberOfEntities",
		SUPPORT_CHANNEL: "supportChannel",
		SUPPORT_RESPONSE_TIME: "supportResponseTime",
		FEATURE_REQUESTS: "featureRequests"
	},
	SUBSCRIPTIONS: {
		PLANS: [
			{ tierId: 4, name: "Free", level: 0 },
			{ tierId: 3, name: "Pro", level: 1 },
			{ tierId: 2, name: "Business", level: 2 },
			{ tierId: 1, name: "Enterprise", level: 3 },
		],
		PERIODS: {
			YEARLY: 'YEARLY',
			MONTHLY: 'MONTHLY',
			CUSTOM: 'CUSTOM'
		},
		STATUSES: {
			PENDING: 'PENDING',
			COMPLETED: 'COMPLETED',
			EXPIRED: 'EXPIRED',
			CANCELLED: 'CANCELLED',
			FAILED: 'FAILED'
		}
	}
};
